module.exports = __webpack_public_path__ + "static/img/icon-bindPhone.f29ffda8.png";